import i18next from 'i18next';

i18next.addResources('es_CL', 'Questions', {
  answerPlaceholder: 'Agrega aquí instrucciones adicionales a tu pedido'
});
